var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-section main-section--white"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center add-margin-bottom-full"},[_c('h2',{staticClass:"h1 text-capitalize add-margin-bottom"},[_vm._v(_vm._s(_vm.tag))])]),_vm._v(" "),_c(_vm.selectedLayout,{tag:"component",attrs:{"entries":_vm.contents}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8f9aee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tags/TagsPage.vue
// module id = null
// module chunks = 